import React from 'react';
import ImageGallery from '../components/ImageGallery';
import SEOHeadNative from '../components/SEOHeadNative';

const IRVE: React.FC = () => {
  const galleryImages = [
    {
      src: '/images/irve/borne-wallbox.jpg',
      title: 'Installation borne Wallbox',
      description: 'Pose de borne de recharge domestique haute qualité'
    },
    {
      src: '/images/irve/borne-publique.jpg',
      title: 'Borne de recharge publique',
      description: 'Installation de bornes pour collectivités et entreprises'
    },
    {
      src: '/images/irve/cablage-irve.jpg',
      title: 'Câblage IRVE',
      description: 'Raccordement électrique sécurisé aux normes IRVE'
    },
    {
      src: '/images/irve/maintenance-borne.jpg',
      title: 'Maintenance des bornes',
      description: 'Service après-vente et maintenance préventive'
    },
    {
      src: '/images/irve/installation-garage.jpg',
      title: 'Installation garage privé',
      description: 'Solution de recharge optimisée pour particuliers'
    },
    {
      src: '/images/irve/borne-entreprise.jpg',
      title: 'Bornes pour entreprises',
      description: 'Solutions de recharge pour flottes et collaborateurs'
    }
  ];

  return (
    <div>
      <SEOHeadNative
        title="IRVE - Bornes de Recharge - OZARKS ELEC"
        description="Installateur IRVE qualifié à Viesly. Installation bornes de recharge véhicules électriques, particuliers et entreprises. Certifié IRVE dans l'Aisne, Thiérache et région Nord."
        keywords="installateur IRVE Viesly, borne recharge véhicule électrique, installation IRVE Aisne, borne Wallbox, recharge voiture électrique Nord"
        canonical="/irve"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "IRVE - Bornes de Recharge",
          "description": "Installation de bornes de recharge pour véhicules électriques, particuliers et entreprises. Installateur certifié IRVE.",
          "provider": {
            "@type": "ElectricalContractor",
            "name": "OZARKS ELEC",
            "url": "https://ozarkselec.com"
          },
          "areaServed": ["Aisne", "Thiérache", "Caudrésis", "Catésis", "Nord"],
          "serviceType": "Installation IRVE"
        }}
      />
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark">
                IRVE - Bornes de <span className="ozarks-blue-medium">Recharge</span>
              </h1>
              
              <div style={{marginTop: '60px', textAlign: 'left'}}>
                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🚗 Installation bornes particuliers</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Installation de bornes de recharge domestiques pour véhicules électriques. 
                    Solutions adaptées à votre habitation avec étude personnalisée de votre installation électrique.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🏢 Solutions entreprises</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Bornes de recharge pour entreprises, collectivités et copropriétés. 
                    Gestion des accès, supervision à distance et solutions de paiement intégrées.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>⚡ Puissances et technologies</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Large gamme de puissances : de 7,4 kW à 22 kW en triphasé. 
                    Bornes intelligentes avec pilotage énergétique et connectivité WiFi/4G.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🔧 Maintenance et SAV</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Service après-vente réactif et maintenance préventive. 
                    Diagnostic à distance et intervention rapide en cas de dysfonctionnement.
                  </p>
                </div>

                <div style={{backgroundColor: 'var(--ozarks-light-gray)', padding: '20px', borderRadius: '10px', marginTop: '40px'}}>
                  <h4 className="ozarks-blue-dark" style={{marginBottom: '15px'}}>🏅 Expertise IRVE</h4>
                  <p className="ozarks-gray" style={{lineHeight: '1.7', marginBottom: '0'}}>
                    <strong>Spécialiste des installations IRVE</strong> (Infrastructure de Recharge de Véhicule Électrique). 
                    Installation professionnelle selon les normes en vigueur avec garantie de conformité.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Galerie interactive de réalisations */}
      <div className="r t-rec t-rec_pt_60 t-rec_pb_60" style={{paddingTop: '60px', paddingBottom: '60px', backgroundColor: 'var(--ozarks-light-gray)'}}>
        <div className="t-container">
          <div className="t-col t-col_12">
            <div className="t-section__title t-title t-title_xs t-align_center t-margin_auto">
              <div style={{fontSize: '32px'}} className="ozarks-blue-dark">
                Galerie de nos <span className="ozarks-blue-medium">installations</span>
              </div>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginTop: '15px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Découvrez nos installations de bornes de recharge IRVE. 
                Cliquez sur les images pour les voir en grand format.
              </div>
            </div>
            
            <ImageGallery images={galleryImages} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IRVE;